import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FeaturesConfigModule, GlobalMessageModule, I18nModule } from '@spartacus/core'
import {
  AnonymousConsentsDialogModule,
  GlobalMessageComponentModule,
  KeyboardFocusModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
  PwaModule,
  SeoModule,
  SkipLinkModule,
  SpinnerModule
} from '@spartacus/storefront'
import { EbBackToTopButtonModule } from '../back-to-top-button/eb-back-to-top-button.module'
import { EbNoSalesAreaMessageModule } from '../no-sales-area-message/eb-no-sales-area-message.module'
import { EbStorefrontComponent } from './eb-storefront.component'

@NgModule({
  declarations: [EbStorefrontComponent],
  imports: [
    CommonModule,
    RouterModule,
    GlobalMessageModule,
    OutletModule,
    OutletRefModule,
    PwaModule,
    PageLayoutModule,
    SeoModule,
    PageSlotModule,
    AnonymousConsentsDialogModule,
    FeaturesConfigModule,
    SkipLinkModule,
    KeyboardFocusModule,
    SpinnerModule,
    GlobalMessageComponentModule,
    I18nModule,
    EbNoSalesAreaMessageModule,
    EbBackToTopButtonModule
  ],
  exports: [EbStorefrontComponent]
})
export class EbStorefrontModule {}
